module.exports = __webpack_public_path__ + "post-listing-block-2-hotpads-3iUEUZV.png";